import { IMAGES } from "../data/site";

const HIGHLIGHTS = [
  "100% Dedicated Ladies Sanctuary",
  "Expert Hair & Makeup Artists",
  "Premium Products",
  "Hygiene Guaranteed",
];

export const Hero = () => (
  <section
    id="home"
    data-testid="hero-section"
    className="grain relative flex min-h-screen flex-col overflow-hidden bg-[#383D33]"
  >
    <img
      src={IMAGES.hero}
      alt="Elegant interior of Her Styles Ladies Salon"
      className="absolute inset-0 h-full w-full object-cover opacity-60"
      loading="eager"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-[#383D33]/70 via-[#383D33]/45 to-[#383D33]" />

    <img
      src="/logo.png"
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute -right-10 top-1/2 hidden w-[420px] -translate-y-1/2 opacity-[0.14] md:block lg:right-16 lg:w-[520px]"
    />

    <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-1 flex-col items-center justify-center px-5 pb-16 pt-32 text-center sm:px-8">
      <img
        src="/logo.png"
        alt="Her Styles Ladies Salon logo"
        data-testid="hero-logo-image"
        className="hero-fade h-28 w-28 object-contain sm:h-36 sm:w-36"
        style={{ animationDelay: "0.05s" }}
      />

      <p
        className="hero-fade mt-6 font-body text-xs font-medium uppercase tracking-[0.4em] text-[#C9A24B] sm:text-sm"
        style={{ animationDelay: "0.15s" }}
      >
        Ladies Salon &bull; Al Qusais, Dubai
      </p>

      <h1
        className="hero-fade mt-6 font-brand text-4xl uppercase leading-tight tracking-[0.18em] text-[#F2EFE6] sm:text-5xl lg:text-6xl"
        style={{ animationDelay: "0.35s" }}
        data-testid="hero-title"
      >
        Her Styles
      </h1>

      <div className="hero-fade mt-6 flex items-center gap-3" style={{ animationDelay: "0.5s" }}>
        <span className="gold-hairline h-px w-14 sm:w-24" />
        <span className="h-2 w-2 rotate-45 border border-[#C9A24B]" />
        <span className="gold-hairline h-px w-14 sm:w-24" />
      </div>

      <p
        className="hero-fade mt-6 max-w-xl font-brand text-xl italic text-[#D8C28A] sm:text-2xl"
        style={{ animationDelay: "0.65s" }}
      >
        Bespoke Beauty &amp; Luxury Wellness Sanctuary
      </p>

      <p
        className="hero-fade mt-5 max-w-lg font-body text-sm leading-relaxed text-[#F2EFE6]/75 sm:text-base"
        style={{ animationDelay: "0.8s" }}
      >
        From precision hair artistry to relaxing spa treatments, every detail at Her Styles is
        crafted around you.
      </p>

      <div
        className="hero-fade mt-10 flex flex-col items-center gap-4 sm:flex-row"
        style={{ animationDelay: "0.95s" }}
      >
        <a
          href="#book"
          data-testid="hero-book-now-button"
          className="btn-shimmer rounded-full bg-[#C9A24B] px-9 py-4 font-body text-sm font-semibold uppercase tracking-[0.2em] text-[#383D33] shadow-lg shadow-[rgba(201,162,75,0.3)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#D4AF37]"
        >
          Book Appointment
        </a>
        <a
          href="#services"
          data-testid="hero-explore-services-button"
          className="rounded-full border border-[#F2EFE6]/50 px-9 py-4 font-body text-sm font-medium uppercase tracking-[0.2em] text-[#F2EFE6] transition-[border-color,color,background-color,transform] duration-300 hover:-translate-y-0.5 hover:border-[#C9A24B] hover:text-[#C9A24B]"
        >
          Explore Services
        </a>
      </div>
    </div>

    <div
      className="hero-fade relative z-10 border-t border-[rgba(201,162,75,0.25)] bg-[#454538]/70 backdrop-blur-sm"
      style={{ animationDelay: "1.15s" }}
      data-testid="hero-highlights-strip"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 divide-y divide-[rgba(201,162,75,0.15)] px-5 sm:grid-cols-2 sm:divide-y-0 sm:px-8 lg:grid-cols-4 lg:divide-x">
        {HIGHLIGHTS.map((item) => (
          <div
            key={item}
            className="flex items-center justify-center gap-3 py-4 text-center sm:py-5"
          >
            <span className="h-1.5 w-1.5 rotate-45 bg-[#C9A24B]" />
            <span className="font-body text-xs font-medium uppercase tracking-[0.18em] text-[#F2EFE6]/85">
              {item}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
